var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80151 5.58523V11.5239H6.72216V5.58523C7.83897 5.18867 8.64282 4.13327 8.64282 2.88098C8.64282 1.28969 7.35313 0 5.76184 0C4.17055 0 2.88086 1.28969 2.88086 2.88098C2.88086 4.13327 3.68471 5.18864 4.80151 5.58523Z",
    fill: "#59B974"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68261 8.8024V9.74259C9.46596 10.0096 10.5636 10.6098 10.5636 11.0439C10.5636 11.6181 8.64873 12.4843 5.76196 12.4843C2.87519 12.4843 0.960326 11.6181 0.960326 11.0439C0.960326 10.6098 2.05891 10.0096 3.84131 9.74259V8.8024C1.72667 9.07807 0 9.82424 0 11.0438C0 12.6207 2.89909 13.4446 5.76196 13.4446C8.62483 13.4446 11.5239 12.6207 11.5239 11.0438C11.5239 9.82424 9.79725 9.07804 7.68261 8.8024Z",
    fill: "#59B974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationIcon);
export default __webpack_public_path__ + "static/media/CurrentLocationIcon.d1ef1d3ba0db50da1eea9fb05a2973a8.svg";
export { ForwardRef as ReactComponent };